/**
 * 对接@fe/common-navbar获取用户信息
 * @author chenqunfeng
 * @since 18/06/06
 */

import store from 'store';
import { setUserInfo } from 'actions/user-info';

/**
 * 初始化登陆状态
 * @param {*} callback 初始化回调函数
 */
export function initSSO(callback) {
  const addSigninCallback = window.COMMON_NAVBAR.addSigninCallback;
  addSigninCallback &&
    addSigninCallback(data => {
      store.dispatch(setUserInfo(data));
      if (callback) {
        callback(data);
      }
    });
}
